import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DVMService } from '../../services/dvm.service';
import { UtilsService } from '../../services/utils.service';
import { BreadcrumbsService } from 'src/app/layout/breadcrumbs/service/breadcrumbs.service';

@Component({
  selector: 'app-sb-workflows',
  templateUrl: './sb-workflows.component.html',
  styleUrls: ['./sb-workflows.component.scss'],
})
export class SbWorkflowsComponent implements OnInit {
  workflowsList: Array<any>;

  selectedWorkflowID: number;

  constructor(
    private route: ActivatedRoute,
    private utilsService: UtilsService,
    private breadcrumbsService: BreadcrumbsService
  ) { }

  ngOnInit(): void {
    this.workflowsList = this.route.snapshot.data.flows.workflows.sort(function (a, b) {
      let item1 = a.sort;
      let item2 = b.sort;
      // Compare the 2 dates
      if (item1 < item2) return -1;
      if (item1 > item2) return 1;
      return 0;
    });
    console.log(this.workflowsList);

    const bc = [
      {
        label: 'Dashboard',
        url: '/dashboard',
      },
      {
        label: 'Sitesbuilder',
        url: '/sitesbuilder/private/list',
      },
      {
        label: 'Workflows',
        url: '',
      },
    ];
    this.breadcrumbsService.set(bc);
  }

  public onTemplateSelected(workflow) {
    this.selectedWorkflowID = workflow.id;
  }

  public goToWorkflow(workflow) {
    const url = `/sitesbuilder/private/editor/${workflow.id}?venue_id=${workflow.venue_id}&map_id=${workflow.map_id}`;
    this.utilsService.redirectRefreshed((window.location.href = url));
  }
}
